import { render } from "./BasketComponent.vue?vue&type=template&id=da3510bc&ts=true"
import script from "./BasketComponent.ts?vue&type=script&lang=ts"
export * from "./BasketComponent.ts?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__